"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.to-string");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _index = _interopRequireDefault(require("./CommunityDynamics/index.vue"));
var _index2 = _interopRequireDefault(require("./PraiseRank/index.vue"));
var _DetailView = _interopRequireDefault(require("./DetailView.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityDynamics',
  components: {
    CommunityDynamicsList: _index.default,
    PraiseRankList: _index2.default,
    CommunityDynamicsDetail: _DetailView.default
  },
  data: function data() {
    return {
      activeTab: 'communityDynamics',
      detailTabs: [],
      // 详情标签页列表
      detailTabIndex: 0 // 详情标签页索引计数器
    };
  },
  methods: {
    handleTabClick: function handleTabClick(tab) {
      this.activeTab = tab.name;
    },
    // 查看详情
    handleViewDetail: function handleViewDetail(row, type) {
      var _this = this;
      var newTabName = "detail-".concat(++this.detailTabIndex);
      this.detailTabs.push({
        title: "\u52A8\u6001\u8BE6\u60C5 - ".concat(row.id),
        name: newTabName,
        detailData: _objectSpread({}, row),
        type: type ? type.toString() : '0'
      });
      this.$nextTick(function () {
        _this.activeTab = newTabName;
      });
    },
    // 移除标签页
    handleTabRemove: function handleTabRemove(targetName) {
      // 如果关闭的是详情页标签
      if (targetName.startsWith('detail-')) {
        this.detailTabs = this.detailTabs.filter(function (tab) {
          return tab.name !== targetName;
        });
        // 如果关闭的是当前激活的标签，则切换回社区动态
        if (this.activeTab === targetName) {
          this.activeTab = 'communityDynamics';
        }
      }
    },
    handleDetailGoBack: function handleDetailGoBack(tabName) {
      this.handleTabRemove(tabName);
    }
  }
};